'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewsCarousel = function () {
  function ReviewsCarousel(el) {
    (0, _classCallCheck3.default)(this, ReviewsCarousel);

    var _this = this;
    var context = { context: el };

    this.els = {
      el: el,
      slides: (0, _functional.getElement)('.rev-Carousel_Items', context),
      controls: (0, _functional.getElement)('.rev-Carousel_Controls', context),
      prevControl: (0, _functional.getElement)('.rev-Carousel_Control-prev', context),
      nextControl: (0, _functional.getElement)('.rev-Carousel_Control-next', context)
    };

    this.amountOfDotsWanted = null;

    this.carousel = new _siema2.default({
      selector: this.els.slides,
      duration: 500,
      perPage: 1,
      onInit: function onInit() {
        _this.initialiseControls(this);
      }
    });
  }

  (0, _createClass3.default)(ReviewsCarousel, [{
    key: 'initialiseControls',
    value: function initialiseControls(carousel) {
      var _this2 = this;

      var checkIfControlsShouldBeDisabled = function checkIfControlsShouldBeDisabled(carousel) {
        carousel.currentSlide === 0 ? _this2.els.prevControl.setAttribute('disabled', true) : _this2.els.prevControl.removeAttribute('disabled');

        carousel.currentSlide === carousel.innerElements.length - 1 ? _this2.els.nextControl.setAttribute('disabled', true) : _this2.els.nextControl.removeAttribute('disabled');
      };

      checkIfControlsShouldBeDisabled(carousel);

      this.els.prevControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return carousel.prev();

              case 2:

                checkIfControlsShouldBeDisabled(carousel);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      })));
      this.els.nextControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return carousel.next();

              case 2:

                checkIfControlsShouldBeDisabled(carousel);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      })));
    }
  }]);
  return ReviewsCarousel;
}();

exports.default = ReviewsCarousel;